import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "radioButtonChecked",
  "use": "radioButtonChecked-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"radioButtonChecked\">\n<rect x=\"0.5\" y=\"0.5\" width=\"21\" height=\"21\" rx=\"10.5\" fill=\"#F2F8F8\" stroke=\"#007770\" />\n<rect x=\"6.41666\" y=\"6.41675\" width=\"9.16667\" height=\"9.16667\" rx=\"4.58333\" fill=\"#007770\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol